"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Serializer = void 0;
const bs58check = require("bs58check");
class Serializer {
    async serialize(message) {
        const str = JSON.stringify(message);
        return bs58check.encode(Buffer.from(str));
    }
    async deserialize(encoded) {
        if (typeof encoded !== 'string') {
            throw new Error('Encoded payload needs to be a string');
        }
        return JSON.parse(bs58check.decode(encoded).toString());
    }
}
exports.Serializer = Serializer;
//# sourceMappingURL=Serializer.js.map